module.exports = __webpack_public_path__ + "img/rafamet.89153fab.jpg";